/* eslint-disable */


export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {

    // find all gallery components
    $( ".component.image-gallery" ).each(function( index ) {
    });



    var galleryImages = $('.gallery-item');
    var captions = $('.caption-item');

    galleryImages.on('click', toggleAccordion);


    function toggleAccordion(e) {
      e.preventDefault();
      var galleryImages = $(this).parent().find('.gallery-item');
      console.log(galleryImages);
      galleryImages.removeClass('active');
      $(this).addClass('active');

      var index = $(this).index();
      var captions = $(this).parent().parent().find('.caption-item');

      captions.removeClass('active');
      captions.eq(index).addClass('active');

    }

    /*
    $(window).resize(function() {
      onResize();
    });

    function onResize() {

       if ($(window).width() < 744) {
          console.log('Less than 744');
       }
      else {
         console.log('More than 744');
      }

    }

    onResize();
    */






  },
};



// WEBPACK FOOTER //
// ./scripts/components/image-gallery.js